import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { isMac } from '../../utils/Agent/Agent';

const FloatingTooltip: React.FC = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(false), 10000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className="fixed top-6 inset-x-0 flex justify-center pointer-events-none z-50">
          <div className="bg-black text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium pointer-events-auto">
            Press{' '}
            <span className="bg-white text-black px-1 py-0.5 rounded mx-1 font-mono">
              {isMac ? '⌘' : 'Ctrl'} + Shift
            </span>{' '}
            for fuzzy search !!
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingTooltip;
